import useScrollVelocity from "../../../hooks/scrollvelocity";

function ScrollVelocity() {
  const scrollVelocity = useScrollVelocity();

  return <>Scroll velocity: {scrollVelocity}</>;
}

export default ScrollVelocity;
